const targetEmail = "ilyasela.pro@gmail.com"; // Remplacez cette adresse
const products = document.getElementById("products");
const addBtn = document.getElementById("addProduct");
const form = document.getElementById("projectForm");
const status = document.getElementById("status");
let count = 0;

function addProduct() {
  count++;
  const box = document.createElement("div");
  box.className = "product-box";
  box.innerHTML = `
    <div class="product-title"><span>Produit ${count}</span><button class="remove" type="button">✕</button></div>
    <div class="form-grid">
      <label>Nom du produit<input class="product-name" placeholder="Ex : T-shirt premium"></label>
      <label>Prix (€)<input class="product-price" placeholder="29,90"></label>
      <label class="full">Description<textarea class="product-description" placeholder="Tailles, couleurs, matières..."></textarea></label>
    </div>`;
  box.querySelector(".remove").onclick = () => {
    if (products.children.length > 1) box.remove();
  };
  products.appendChild(box);
}
addProduct();
addBtn.onclick = addProduct;

form.addEventListener("submit", (e) => {
  e.preventDefault();
  const productLines = [...document.querySelectorAll(".product-box")].map((box, i) => {
    const n = box.querySelector(".product-name").value || "Non indiqué";
    const p = box.querySelector(".product-price").value || "Non indiqué";
    const d = box.querySelector(".product-description").value || "Non indiqué";
    return `Produit ${i+1} : ${n}\nPrix : ${p} €\nDescription : ${d}`;
  }).join("\n\n");

  const subject = encodeURIComponent("Nouvelle demande de création de site");
  const body = encodeURIComponent(
`Nom : ${document.getElementById("name").value}
E-mail : ${document.getElementById("email").value}
Téléphone : ${document.getElementById("phone").value}
Activité : ${document.getElementById("business").value}
Catégorie : ${document.getElementById("category").value}

Présentation :
${document.getElementById("about").value}

Produits :
${productLines}`
  );

  if (targetEmail.includes("VOTRE-EMAIL")) {
    status.textContent = "Le site est prêt. Il reste seulement à remplacer l’adresse e-mail dans script.js.";
    return;
  }
  window.location.href = `mailto:${targetEmail}?subject=${subject}&body=${body}`;
});